import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Button, useIsMounted } from 'seagull';
import { GoogleIcon } from 'seagull/icons';
import { useIoContext, useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './GoogleButton.module.scss';
export function NativeGoogleButton(param) {
    let { testId, width, scopes, onCredential, onError } = param;
    var _window_googleAuthClientId;
    const { t } = useLocaleKeys('pages.auth');
    const { nativeGoogleAuth, getNativePlatform } = useIoContext();
    const googleIosClientId = useStore((state)=>state.session.googleIosClientId);
    const clientId = getNativePlatform() === 'android' ? (_window_googleAuthClientId = window.googleAuthClientId) !== null && _window_googleAuthClientId !== void 0 ? _window_googleAuthClientId : '' : googleIosClientId;
    const [loading, setLoading] = useState(false);
    const isMounted = useIsMounted();
    async function handleClick() {
        if (loading) return;
        setLoading(true);
        try {
            const response = await nativeGoogleAuth.signIn({
                clientId,
                scopes
            });
            if (isMounted()) {
                await onCredential(response);
            }
        } catch (error) {
            if (isMounted()) {
                onError(error);
            }
        } finally{
            if (isMounted()) {
                setLoading(false);
            }
        }
    }
    if (clientId === '') return null;
    return /*#__PURE__*/ _jsx(Box, {
        testId: testId,
        className: styles.buttonContainer,
        children: /*#__PURE__*/ _jsx(Button, {
            testId: "native-google-login",
            bi: {
                name: 'native_google_signin'
            },
            skin: "primaryOutline",
            onClick: handleClick,
            loading: loading,
            prefixIcon: /*#__PURE__*/ _jsx(GoogleIcon, {
                size: 18
            }),
            style: width != null ? {
                width
            } : undefined,
            children: t.continueWithGoogle()
        })
    });
}
